function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.53 1.71H7.38l-.14-.54A1.45 1.45 0 005.83.06H4.17a1.45 1.45 0 00-1.41 1.11l-.14.54H.47a.41.41 0 000 .82h.44l.34 6.24a1.24 1.24 0 001.24 1.17h5a1.24 1.24 0 001.26-1.17l.34-6.24h.44a.41.41 0 100-.82zm-6-.34a.65.65 0 01.64-.49h1.66a.65.65 0 01.62.49l.08.34H3.47zm4.39 7.36a.42.42 0 01-.41.39h-5a.42.42 0 01-.41-.39l-.35-6.2h6.52z",
  fill: "#828282"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.35 3.35a.42.42 0 00-.41.42v4.11a.42.42 0 00.83 0V3.77a.42.42 0 00-.42-.42zM5 3.35a.41.41 0 00-.41.42v4.11a.41.41 0 00.82 0V3.77A.41.41 0 005 3.35zM6.65 3.35a.42.42 0 00-.42.42v4.11a.42.42 0 00.83 0V3.77a.42.42 0 00-.41-.42z",
  fill: "#828282"
});

var SvgTrash = function SvgTrash(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 10 10"
  }, props), _ref, _ref2);
};

export default SvgTrash;